import { TThunkAction } from '../../types/redux';
import { TUser } from '../../types/currentUser';
import { resolveUser } from '../../services/user';
import { setStatusSucceed } from './types';

export function getUserAction(): TThunkAction<Promise<TUser>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const user = await resolveUser({ httpApi, logger });
    dispatch(setStatusSucceed(user));

    return user;
  };
}
